export const categoryAriaLabel = "Vn_Vc";
export const folderAriaLabel = "BtwrO";
export default {categoryAriaLabel,folderAriaLabel};